module.exports = __webpack_public_path__ + "static/media/no_orders.b8651b90.svg";